import React from 'react';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { WhatIsCLVN } from '../components/WhatIsCLVN';
import { Applications } from '../components/Applications';
import { VisualEngine } from '../components/VisualEngine';
import { Timeline } from '../components/Timeline';
import { Papers } from '../components/Papers';
import { Author } from '../components/Author';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="flex flex-col w-full" data-id="element-282" data-mp="24htpwg438ogi">
      <Nav data-id="element-283" data-mp="24iv9xa330lad" />
      <main data-id="element-284" data-mp="29gdc8hmlg29e">
        <Hero data-id="element-285" data-mp="29flofsz8n8to" />
        <div id="marco" data-id="element-286" data-mp="29f27aehewogp">
          <WhatIsCLVN data-id="element-287" data-mp="29etu0lhdnh4z" />
        </div>
        <div id="aplicaciones" data-id="element-288" data-mp="2dhgrb1wthu9k">
          <Applications data-id="element-289" data-mp="2dirt4w6pcry1" />
        </div>
        <div id="motor" data-id="element-290" data-mp="2dfm6dnljq25h">
          <VisualEngine data-id="element-291" data-mp="3kvk62l8hf36i" />
        </div>
        <div id="timeline" data-id="element-292" data-mp="3kuihrf2ggk6u">
          <Timeline data-id="element-293" data-mp="3kxd2z8tam91b" />
        </div>
        <div id="papers" data-id="element-294" data-mp="3owlwqdoc26wv">
          <Papers data-id="element-295" data-mp="3ovucfz06rvlw" />
        </div>
        <div id="autor" data-id="element-296" data-mp="3ov2i0ribs3x7">
          <Author data-id="element-297" data-mp="30wrnkc0kxpdf" />
        </div>
        <div id="contacto" data-id="element-298" data-mp="30vqe2bz7paxt">
          <Contact data-id="element-299" data-mp="30w05m3zwnq5m" />
        </div>
      </main>
      <Footer data-id="element-300" data-mp="2vxycsrcogcgy" />
    </div>;
}